export default (() => {
    const global = {
        elements: {},
        pageData: {},
        signalRTimeout: null
    };

    function initialise(config) {
        _cacheDOM();
        _cachePageData(config);
        _bindSignalREvents();
        global.pageData.connection.hub.start();

        global.signalRTimeout = setTimeout(_timeoutFunction, 15000);
    }

    function _cacheDOM() {
        // page sections
        global.elements.loadingSpinnerSection = document.querySelector('[data-loading-spinner]');
        global.elements.closeSuccessSection = document.querySelector('[data-close-success]');
        global.elements.closePendingSection = document.querySelector('[data-close-pending]');
        global.elements.headingStripe = document.querySelector('[data-heading-stripe]');
    }

    function _cachePageData(config) {
        global.pageData = config;
    }

    function _bindSignalREvents() {
        global.pageData.connection[global.pageData.hubName].client.closeSuccess = _closeSuccess;
    }

    function _closeSuccess(portfolioId) {
        if (global.pageData.portfolioId === portfolioId) {
            const closeCompleteTitle = 'Plan Closed';

            _killTimeout();
            _hideLoadingSpinner();
            document.title = `${closeCompleteTitle} | Wealthify.com`;
            global.elements.headingStripe.heading = closeCompleteTitle;
            global.elements.closeSuccessSection.style.removeProperty('display');
            global.elements.closePendingSection.style.display = 'none';
        }
    }

    function _hideLoadingSpinner() {
        global.elements.loadingSpinnerSection.classList.add('u-display__none');
    }

    function _timeoutFunction() {
        // remove SignalR event handler
        global.pageData.connection[global.pageData.hubName].client.closeSuccess = null;
        
        _hideLoadingSpinner();
        global.elements.closePendingSection.style.removeProperty('display');
    }

    function _killTimeout() {
        if (global.signalRTimeout) {
            clearTimeout(global.signalRTimeout);
        }
    }

    return { initialise };
})();